import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import isEmpty from "lodash/isEmpty";

import {
  getCartOrderLineItems,
  getCartOrderMedleySets,
  getCartOrderProductSets,
  getCartOrder,
  getIsCartUpdating,
} from "@store/selectors/cart";
import { getIsLockerShop } from "@selectors/store";

import useGetVariantDetails from "@hooks/cart/use-get-variant-details";

import { updateCart } from "@slices/cart";

//Note:-The same logic needs to be applied to locker listing as well

const useFetchVariantList = () => {
  const dispatch = useDispatch();

  const lineItems = useSelector(getCartOrderLineItems);
  const productSets = useSelector(getCartOrderProductSets);
  const medleySets = useSelector(getCartOrderMedleySets);
  const cartOrder = useSelector(getCartOrder);
  const isLockerShop = useSelector(getIsLockerShop);
  const isCartUpdating = useSelector(getIsCartUpdating);

  //Skip fetching variants in the case of a locker shop, as fetching variants for the locker shop is handled in the locker shop cart component.
  const { productsWithVariantDetails, variantsMapping, variantData, variantDataloading } =
    useGetVariantDetails({
      lineItems,
      productSets,
      medleySets,
      skipFetchVariants: isCartUpdating || isLockerShop,
    });

  //to update images of line items and product sets in redux store
  //lineItems does needs to be added in the dependency array to avoid infinite loop
  useEffect(() => {
    const { lineItemsWithDetails, productSetItemsWithDetails, medleySetsWithDetails } =
      productsWithVariantDetails;
    if (
      !(
        isEmpty(lineItemsWithDetails) &&
        isEmpty(productSetItemsWithDetails) &&
        isEmpty(medleySetsWithDetails)
      )
    ) {
      dispatch(
        updateCart({
          ...cartOrder,
          lineItems: lineItemsWithDetails,
          productSets: productSetItemsWithDetails,
          medleyItemSets: medleySetsWithDetails,
          variantsMapping,
        }),
      );
    }
  }, [productsWithVariantDetails]);

  return {
    variantData,
    variantDataloading,
    variantsMapping,
  };
};
export default useFetchVariantList;
